// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1z1Jx","logo":"styles_logo__1r_Vc","login__Link__Item":"styles_login__Link__Item__3B10r","login__Link":"styles_login__Link__37cyI"};